export const useConfig = (configName: string) => {
  if (
    configName === 'refunds' &&
    window.appConfig.EXT_CONFIGS &&
    window.appConfig.EXT_CONFIGS.refunds
  ) {
    return window.appConfig.EXT_CONFIGS.refunds
  }
  return null
}
